export enum InputType {
    Gif = `gif`,
    Guest = `guest`,
    GuestIntercom = `guestIntercom`,
    GuestScreenShare = `guestScreenShare`,
    Image = `image`,
    Live = `live`,
    Local = `local`,
    MediaPlayer = `mediaPlayer`,
    Pending = `pending`,
    Playlist = `playlist`,
    Snapshot = `snapshot`,
    Vod = `vod`,
    Web = `web`
}

enum VodEndMode {
    Remove = `remove`,
    Loop = `loop`
}

type AudioSettings = {
    gain?: number;
    mute?: boolean;
    pan?: number;
    stereoBalance?: number;
    volume: number;
};

export type DisplaySettings = {
    cornerCoordinates?: CornerCoordinates;
    crop?: CropCoordinates;
    flip?: { horizontal?: boolean; vertical?: boolean };
    opacity?: number;
};

export type CropCoordinates = {
    bottom: number;
    left: number;
    right: number;
    top: number;
};

export type OutputSize = {
    width: number;
    height: number;
};

export type CornerCoordinates = {
    bottomRight: { x: number; y: number };
    topLeft: { x: number; y: number };
};

//used when requesting creation
export type InputRequest = {
    displayName?: string;
    type?: InputType;
    layerIndex?: number;
    resourceURI?: string;
    mediaResource?: string;
    autoPlayOnProgram?: boolean;
    autoPauseOffProgram?: boolean;
    useParentsAudioSettings?: boolean;
    paused?: boolean;
    selectedPlaylistInputId?: string;
    webSourceData?: string;
};

export type InputResponse = {
    alpha?: number;
    assetId?: string;
    audioDeviceID?: string;
    audioEnabled?: boolean;
    audio?: AudioSettings;
    audioDataStreamId?: number;
    audioStreams?: { language: string; streamIndex: number }[]; //TODO: language types
    audioVideoSynchronisation?: number;
    broadcastName?: string;
    coordinates?: number[];
    countdown?: number; //is this supposed to be here ?
    creationDate?: number;
    crop?: CropCoordinates;
    cropMigration2021?: boolean;
    display?: DisplaySettings;
    displayName: string;
    duration?: number;
    height?: number;
    isConnected?: boolean;
    isLive?: boolean;
    isoRecording?: {
        state: string;
        creationDate: number;
    };
    layerIndex: number;
    liveBuffer?: number;
    mediaAssetId?: string;
    modules?: Record<string, unknown>; //TODO: don't know what this is
    muteSourcesBelow?: boolean;
    numberOfAudioStreams?: number;
    numberOfVideoStreams?: number;
    playbackEndTime?: number;
    playbackSpeed?: number;
    playbackStartTime?: number;
    positionIndex: number;
    preferredAudioStreamIndex?: number;
    previewSettings?: {
        audio: AudioSettings;
        coordinates: number[];
        crop?: CropCoordinates;
        cropMigration2021?: boolean;
        display?: DisplaySettings;
        muteSourcesBelow: boolean;
        playbackSpeed?: number;
        stereoBalance?: number;
        updated?: boolean;
        vodEndMode?: string;
        volume?: number;
    };
    previewURI?: string;
    programSettings?: {
        audio: AudioSettings;
    };
    resourceURI: string;
    stereoBalance?: number;
    thumbnailURI?: string;
    type: string | InputType;
    updated?: boolean;
    userID?: string;
    videoDeviceId?: string;
    videoEnabled?: boolean;
    videoStreamID?: number;
    vodEndMode?: VodEndMode;
    volume?: number;
    width?: number;
};

export enum RenderTarget {
    Clean = "clean",
    Program = "program"
}
